import { useEffect } from "react";
import { sb } from "@/lib/sb";

const SENT = new Set<string>();

function deviceType(): "mobile" | "tablet" | "desktop" {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export function useWebVitalsBeacon(skip: boolean) {
  useEffect(() => {
    if (skip || typeof window === "undefined") return;
    let cancelled = false;
    (async () => {
      const { onLCP, onINP, onCLS, onFCP, onTTFB } = await import("web-vitals");
      if (cancelled) return;

      const send = (metric: string, value: number) => {
        const key = `${metric}:${window.location.pathname}`;
        if (SENT.has(key)) return;
        SENT.add(key);
        sb.from("web_vitals").insert({
          metric,
          value,
          page_url: window.location.pathname,
          device: deviceType(),
        }).then(() => {});
      };

      onLCP((m) => send("LCP", m.value));
      onINP((m) => send("INP", m.value));
      onCLS((m) => send("CLS", m.value));
      onFCP((m) => send("FCP", m.value));
      onTTFB((m) => send("TTFB", m.value));
    })();
    return () => { cancelled = true; };
  }, [skip]);
}
